import type {
  PresentationPhotoSource,
  PresentationPhotoSources,
} from '../diagnostics/planPresentation'

export type PresentationPhotoGroup = {
  key: string
  label: string
  kind: 'plan' | 'nas'
  photos: PresentationPhotoSource[]
  assetCount?: number
  linked?: boolean
  available?: boolean
}

export function groupPresentationPhotos(sources: PresentationPhotoSources): PresentationPhotoGroup[] {
  const groups: PresentationPhotoGroup[] = []

  if (sources.plan_photos.length > 0) {
    groups.push({
      key: 'plan',
      label: 'Фото плана',
      kind: 'plan',
      photos: sources.plan_photos,
      assetCount: sources.plan_photos.length,
    })
  }

  const nasByKey = new Map<string, PresentationPhotoSource[]>()
  for (const photo of sources.nas_photos) {
    const key = photo.source_key ?? 'nas-unknown'
    const list = nasByKey.get(key) ?? []
    list.push(photo)
    nasByKey.set(key, list)
  }

  const seen = new Set<string>()
  for (const nas of sources.nas_sources) {
    const photos = nasByKey.get(nas.source_key) ?? []
    if (photos.length === 0) continue
    seen.add(nas.source_key)
    groups.push({
      key: nas.source_key,
      label: nas.folder_label ?? nas.source_label,
      kind: 'nas',
      photos,
      assetCount: nas.asset_count,
      linked: nas.linked,
      available: nas.available,
    })
  }

  for (const [key, photos] of nasByKey) {
    if (seen.has(key) || photos.length === 0) continue
    groups.push({
      key,
      label: photos[0]?.source_label ?? key,
      kind: 'nas',
      photos,
      assetCount: photos.length,
    })
  }

  return groups
}
